import React from 'react';
import { Horse, useHorse } from '../../contexts/HorseContext';
import { EditIcon, TrashIcon } from 'lucide-react';
interface MasterDataTableProps {
  onEdit: (horse: Horse) => void;
}
export const MasterDataTable: React.FC<MasterDataTableProps> = ({
  onEdit
}) => {
  const {
    horses,
    deleteHorse
  } = useHorse();
  const handleDelete = (id: string) => {
    if (window.confirm('Möchten Sie dieses Pferd wirklich löschen?')) {
      deleteHorse(id);
    }
  };
  return <div className="overflow-x-auto" data-id="element-116">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-117">
        <thead className="bg-[#284755]/10" data-id="element-118">
          <tr data-id="element-119">
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-120">
              Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-121">
              Abstammung
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-122">
              Geburtsjahr
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-123">
              Rasse
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-124">
              Letzte Verwiegung
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-125">
              Aktionen
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-126">
          {horses.length === 0 ? <tr data-id="element-127">
              <td colSpan={6} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-128">
                Keine Pferde vorhanden
              </td>
            </tr> : horses.map(horse => {
          const lastWeight = horse.weights.length > 0 ? horse.weights.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())[0] : null;
          return <tr key={horse.id} className="hover:bg-[#96c11f]/5" data-id="element-129">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-130">
                    {horse.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-131">
                    {horse.lineage || '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-132">
                    {horse.birthYear}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-133">
                    {horse.breed || '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-134">
                    {lastWeight ? `${lastWeight.weight} kg (${lastWeight.date})` : 'Keine Verwiegung'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-135">
                    <button onClick={() => onEdit(horse)} className="text-[#284755] hover:text-[#96c11f] mr-3" data-id="element-136">
                      <EditIcon size={18} data-id="element-137" />
                    </button>
                    <button onClick={() => handleDelete(horse.id)} className="text-[#284755] hover:text-[#96c11f]" data-id="element-138">
                      <TrashIcon size={18} data-id="element-139" />
                    </button>
                  </td>
                </tr>;
        })}
        </tbody>
      </table>
    </div>;
};